import _ from 'underscore';

import { CREATE_FS_DOCS, CREATE_FS_DOC } from 'actions/Types';
import { UploadStatusTypes } from 'constants/EventDocUploadStatuses';

const { Completed, Failed, Uploading } = UploadStatusTypes;

export default (state = {}, action) => {
  //If we just started a new group of docs, set each to uploading status
  if (action.type === CREATE_FS_DOCS) {
    const statusesObject = {};
    _.each(action.payload, file => {
      statusesObject[file.name] = { type: Uploading };
    });
    return statusesObject;
  }

  if (action.type === `${CREATE_FS_DOC}_SUCCESS`) {
    state[action.payload.name] = { type: Completed };
    return { ...state };
  }

  if (action.type === `${CREATE_FS_DOC}_FAILURE`) {
    const { message, payload } = action;
    state[payload.name] = {
      type: Failed
    };
    if (action.message) {
      state[payload.name].message = message;
    }
    return { ...state };
  }

  return state;
};
